import { useCallback, useState } from "react";
import { dispatch } from "../../state/store";
import { setAvailableSmartDashboards } from "../../state/ducks";

import { strCode } from "../../consts";
import { log, notificationService, smartDashboardService, t } from "../../services";

export const useFetchAvailableDashboards = () => {
  const [loading, setLoading] = useState(false);

  const fetchAvailableDashboards = useCallback(async () => {
    setLoading(true);

    let result = [];
    try {
      result = await smartDashboardService.fetchAvailableDashboards();
      dispatch(setAvailableSmartDashboards(result));
    } catch (err) {
      log.error("useFetchAvailableDashboards: Failed to fetch available dashboards", err);
      notificationService.showError({
        title: t(strCode.ERROR_FETCH_DASHBOARDS),
        message: err?.response?.data ? err.response.data : err?.toString()
      });
      dispatch(setAvailableSmartDashboards([]));
    } finally {
      setLoading(false);
    }

    return result;
  }, []);

  return { loading, fetchAvailableDashboards };
};
